export const ERROR_CODE_MAPPING: Record<string, string> = {
  // Ошибки входа и проверки запроса
  'wrong_email_or_password':                        'errors.accounts.wrong_credentials',
  'unauthorized':                                   'errors.system.unauthorized',
  'validation_failed':                              'errors.system.validation_failed',

  // Ошибки пользователей
  'user_login_or_password_is_incorrect':            'errors.user.wrong_credentials',
  'user_account_is_not_found':                      'errors.user.account_not_found',
  'user_is_not_found':                              'errors.user.account_not_found',
  'user_already_exists':                            'errors.user.duplicate_account',
  'user_password_is_illegal':                       'errors.user.illegal_password',

  // Ошибки клиентов
  'customer_is_not_found':                          'errors.customers.customer_not_found',
  'customer_already_exists':                        'errors.customers.duplicate_customer',
  'customer_with_the_same_pd_already_exists':       'errors.customers.duplicate_customer_pd',
  'unknown_customer_type':                          'errors.customers.unknown_customer_type',
  'customer_vat_is_missing':                        'errors.customers.missed_vat',
  'customer_passport_is_missing':                   'errors.customers.missed_passport',
  'no_access_for_account':                          'errors.customers.no_access_for_account',
  'multiple_accounts_for_customer':                 'errors.customers.multiple_account_for_person',
  'multiple_customers_for_account':                 'errors.customers.multiple_customers_for_person',

  // Ошибки аккаунтов
  'customer_account_is_not_found':                  'errors.accounts.account_not_found',
  'customer_account_already_exists':                'errors.accounts.duplicate_account',
  'customer_email_is_invalid':                      'errors.accounts.invalid_email',
  'wrong_restore_code':                             'errors.accounts.wrong_restore',
  'illegal_password_for_account':                   'errors.accounts.illegal_password',
  'customer_login_or_password_is_incorrect':        'errors.accounts.wrong_credentials',

  // Ошибки склада
  'facility_is_not_found':                          'errors.warehouse.facility_not_found',
  'duplicate_facility':                             'errors.warehouse.duplicate_facility',
  'wrong_character_in_facility_code':               'errors.warehouse.invalid_facility_code',
  'unit_type_is_not_found':                         'errors.warehouse.unit_type_not_found',
  'duplicate_unit_type':                            'errors.warehouse.duplicate_unit_type',
  'wrong_character_in_unit_type_code':              'errors.warehouse.invalid_unit_type_code',
  'unit_is_not_found':                              'errors.warehouse.unit_not_found',
  'duplicate_unit':                                 'errors.warehouse.duplicate_unit',
  'unknown_unit':                                   'errors.warehouse.unknown_unit_status',
  'unit_status_cannot_be_changed':                  'errors.warehouse.transition_forbidden',
  'no_vacated_unit':                                'errors.warehouse.no_vacated_unit',
  'wrong_character_in_unit_code':                   'errors.warehouse.invalid_unit_code',

  // Ошибки медиа
  'file_name_conflict':                             'errors.media.file_name_conflict',
  'file_is_too_big':                                'errors.media.file_is_too_big',
  'wrong_path_for_file':                            'errors.media.wrong_path',

  // Ошибки уведомлений
  'channel_not_found':                              'errors.notifications.channel_not_found',
  'duplicated_channel':                             'errors.notifications.duplicate_channel',
  'address_required_for_static_recipient':          'errors.notifications.address_required',
  'invalid_channel_name':                           'errors.notifications.invalid_channel_name',
  'missed_required_option':                         'errors.notifications.options_required',
  'event_not_found':                                'errors.notifications.event_not_found',
  'duplicated_event':                               'errors.notifications.duplicate_event',
  'invalid_event_name':                             'errors.notifications.invalid_event_name',
  'event_template_not_found':                       'errors.notifications.event_template_not_found',
  'notifications_template_name_is_invalid':         'errors.notifications.invalid_template_name',
  'duplicated_event_template':                      'errors.notifications.duplicate_event_template',
  'notification_template_not_found':                'errors.notifications.template_not_found',
  'notification_template_is_duplicated':            'errors.notifications.duplicate_template',
  'notification_history_template_not_found':        'errors.notifications.template_history_not_found',
  'invalid_environment_name':                       'errors.notifications.invalid_environment_name',

  // Ошибки контрактов
  'contract_is_not_found':                          'errors.contracts.contract_not_found',
  'contract_has_open_invoices':                     'errors.contracts.contract_has_open_invoices',
  'unknown_period':                                 'errors.contracts.unknown_period',
  'terminated_contract':                            'errors.contracts.terminated_contract',
  'no_default_payment_method':                      'errors.contracts.no_default_payment_method',
  'contract_status_cannot_be_changed':              'errors.contracts.transition_forbidden',
  'wrong_start_date':                               'errors.contracts.wrong_start_date',
  'unknown_contract_type':                          'errors.contracts.unknown_contract_type',

  // Ошибки инвойсов
  'invoice_is_not_found':                           'errors.invoices.invoice_not_found',

  // Ошибки платежей
  'payment_method_is_not_found':                    'errors.payments.payment_method_not_found',

  // Ошибки шаблонов документов
  'document_template_not_found':                    'errors.templates.template_not_found',
  'document_template_is_duplicated':                'errors.templates.duplicate_template',
  'invalid_template_name_for_document':             'errors.templates.invalid_template_name',
  'document_template_history_not_found':            'errors.templates.template_history_not_found',
  'rendered_resource_not_found':                    'errors.templates.rendered_resource_not_found',
} as const;
